import React from 'react';
import { string, bool, shape, arrayOf, func } from 'prop-types';
import axios from 'axios';

import { constEvent } from '../../utils/constants';
import { dispatchGenericEvent } from '../../utils/dispatch-events';

const Item = ({
  labelDefaultTag,
  labelBtnUseThisAddress,
  labelBtnCurrentlySelected,

  item,
  showAddNewLink,
  cartId,
  endpoints,

  onIsLoading
}) => {
  const { isDefault, isSelected, id, bsl, addressInfo } = item;

  const handleUseThisAddress = e => {
    e.preventDefault();
    onIsLoading(true);

    const data = { address_id: id, cart_id: cartId };

    axios({
      method: 'post',
      url: endpoints?.changeAddress || null,
      data,
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, body, message } = response?.data || {};

        if (success) {
          dispatchGenericEvent(constEvent.CLOSE_MODAL_CHANGE_ADDRESS);

          if (showAddNewLink) {
            dispatchGenericEvent(
              constEvent.UPDATED_DELIVERY_ADDRESS_ON_CART_PAGE,
              body?.cart
            );
            location.reload();
          } else {
            dispatchGenericEvent(constEvent.UPDATED_DELIVERY_ADDRESS);
          }
        }
      })
      .finally(() => onIsLoading(false));
  }; //handleUseThisAddress

  return (
    <div className="change-address__item">
      {isDefault ? (
        <span className="change-address__item-default-indicator">
          {labelDefaultTag}
        </span>
      ) : null}

      <div className="change-address__item-bsl">
        {bsl?.icon ? <img src={bsl?.icon} alt={bsl?.label} /> : null}

        {bsl?.label ? <span>{bsl?.label}</span> : null}
      </div>

      <div className="change-address__item-info">
        {addressInfo?.map((address, index) => (
          <p key={index}>{address}</p>
        ))}
      </div>

      <div className="change-address__item-cta-wrapper">
        <button
          type="button"
          className="btn btn--primary btn--full-width"
          disabled={isSelected}
          onClick={handleUseThisAddress}
        >
          <span>
            {isSelected ? labelBtnCurrentlySelected : labelBtnUseThisAddress}
          </span>
        </button>
      </div>
    </div>
  );
};

Item.propTypes = {
  labelDefaultTag: string.isRequired,
  labelBtnUseThisAddress: string.isRequired,
  labelBtnCurrentlySelected: string.isRequired,

  item: shape({
    isDefault: bool.isRequired,
    isSelected: bool.isRequired,
    id: string.isRequired,
    bsl: shape({
      label: string,
      icon: string
    }).isRequired,
    addressInfo: arrayOf(string)
  }).isRequired,
  showAddNewLink: bool.isRequired,
  cartId: string,
  endpoints: shape({}),

  onIsLoading: func.isRequired
};

export default Item;
